import { COMPANY_MANAGED_TRANSLATIONS, TEAM_MANAGED_TRANSLATIONS } from './constants';

export const getTranslations = (isSimplified: boolean) =>
	isSimplified ? TEAM_MANAGED_TRANSLATIONS : COMPANY_MANAGED_TRANSLATIONS;
